import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";
import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import { StyledTitleOverLimitSubscription } from "app/pages/sales-intelligence/common-components/MultiSelector/styles";
import type { Translatable } from "app/pages/sales-intelligence/types";

const TITLE_TRANSLATABLE: Translatable = {
    key: "si.save-to-list.button.tooltip.quota.title",
};

const TITLE_TRANSLATABLE_TRIAL: Translatable = {
    key: "si.quotaLimit.tooltip.header.trial",
};

type I18nKeyModifier = "account" | "company" | "company-structure";

type Props = {
    i18nKeyModifier: I18nKeyModifier;
};

const SaveToListQuotaTooltipContent = ({ i18nKeyModifier }: Props) => {
    const canDeleteOpportunities = salesSettingsHelper.canDeleteOpportunities();
    return (
        <>
            <I18n
                translatable={canDeleteOpportunities ? TITLE_TRANSLATABLE : TITLE_TRANSLATABLE_TRIAL}
                element={StyledTitleOverLimitSubscription}
            />
            <I18n
                translatable={{
                    key: canDeleteOpportunities
                        ? `si.save-to-list.${i18nKeyModifier}.button.tooltip.quota.sub-title`
                        : `si.save-to-list.${i18nKeyModifier}.button.tooltip.quota.sub-title.trial`,
                }}
                element="div"
            />
        </>
    );
};

export default SaveToListQuotaTooltipContent;
